/**
 * SidebarSubnavigationLink Selectors
 */
import { createSelector } from 'reselect';

// Selectors
import { selectLocationPathname } from '../../../../../../workspaces/react-router-selectors';

type State = Record<string, any>;

interface Props {
    pathname: string;
}

const selectPathname = (state: State, props: Props) => props.pathname;

const makeSelectIsActive = () =>
    createSelector(
        [selectLocationPathname, selectPathname],
        (locationPathnameState, pathnameState) =>
            locationPathnameState === pathnameState

    );

export { makeSelectIsActive };
